<template>
  <div class="app-container">
    <SearchComponent
      ref="SearchComponent"
      :selectOrInputList="selectOrInputList"
      @on-search="handleSearch"
      @on-reset="handleReset"
      :synchronous="true"
      :isWarehouse="true"
      :authIdentity="authIdentity"
      @synchronousfun="synchronousfun"
      @isWarehousefun="isWarehousefun"
      @isWarehouseAreafun="isWarehouseAreafun"

      
    ></SearchComponent>

    <div class="left-right">
      <div class="left">
        <TreeNav :treeList="treeList" @onsearch="handleNavSearch" @ontree="handleNavTree"
        @ontreename="handleNavTreename"
        ></TreeNav>
      </div>

      <div class="right">
        <!--   列表     -->
        <TablePublic
          :colLists="colLists"
          :tableData="tableData"
          :paginationFlag="true"
          :total="total"
          :pageParams="queryParams"
          @pageChange="getList"
        >
        </TablePublic>
      </div>
    </div>
    <!-- 弹窗区域 -->
    <Mdialog
      :title="title"
      :visible.sync="dialogVisible"
      width="60%"
      :close-on-click-modal="false"
      :append-to-body="true"
      @closes="cancelAdd"
    >
      <component ref="myform" :is="currentView"></component>
      <span slot="footer">
        <el-button class="batch-button" @click="cancelAdd">取 消</el-button>
        <el-button class="line-button" @click="submitFormAdd">确 定</el-button>
      </span>
    </Mdialog>

    <Mdialog
      :title="areaTitle"
      :visible.sync="areaDialogVisible"
      width="60%"
      :close-on-click-modal="false"
      :append-to-body="true"
      @closes="cancelArea"
    >
      <component ref="areaform" :is="currentView"></component>
      <span slot="footer">
        <el-button class="batch-button" @click="cancelArea">取 消</el-button>
        <el-button class="line-button" @click="submitFormArea">确 定</el-button>
      </span>
    </Mdialog>
  </div>
</template>

<script>
import {
  queryDropDownBox,
  queryWmsStorageAreaDropDownBox,
  queryWmsStorageLocationDropDownBox,
  selectWmsTrayList,
  syncData,
} from '@/api/system/warehousemanagement'

import TreeNav from '@/views/warehousemanagement/components/treeNav'
import TablePublic from '@/components/tablePublic'

import SearchComponent from '@/components/searchComponent'
import Mdialog from '@/components/Mdialog'
import myform from '@/views/warehousemanagement/components/form'
import areaform from '@/views/warehousemanagement/components/areaform'

export default {
  name: 'index',
  components: { SearchComponent, TreeNav, TablePublic, Mdialog, myform, areaform },
  data() {
    return {
      name:'',
      authIdentity: 'system:account',
      type: '',
      dialogWidth: '50%',
      currentView: '',
      dialogVisible: false,
      title: '新建仓库',
      areaTitle: '新建库区库位',
      areaDialogVisible: false,
      queryParams: {
        code: '',
        storageAreaCode: '',
        storageLocCode: '',
        trayCode: '',
        pageNo: 1,
        pageSize: 10,
      },
      searchParams: {},
      selectOrInputList: [
        {
          model: 'storageAreaCode',
          placeholder: '请选择库区',
          value: 'bizCode',
          label: 'bizCode',
          list: [],
          type: 'select',
        },
        {
          model: 'storageLocCode',
          placeholder: '请选择库位',
          value: 'bizCode',
          label: 'bizCode',
          list: [],
          type: 'select',
        },
        {
          model: 'trayCode',
          placeholder: '请选择托盘号',
          value: 'bizCode',
          label: 'bizCode',
          list: [],
          type: 'select',
        },
      ],
      colLists: [
        {
          prop: 'bizCode',
          label: '托盘号',
          isTrue: true,
          align: 'left',
        },
        {
          prop: 'storageLocCode',
          label: '库位',
          isTrue: true,
        },
        {
          prop: 'storageAreaCode',
          label: '库区',
          isTrue: true,
        },
      ],
      loading: false,
      treeList: [],
      tableData: [],
      total: 1,
      activeBox: '',
    }
  },
  created() {
    this.queryDropDownBox()
  },
  computed: {},
  methods: {
    handleNavTreename(name){
      this.name = name
    },
    handleNavTree(bizCode) {
      console.log(bizCode, 'bizCodebizCodebizCode')
      this.activeBox = bizCode

      this.queryParams.storageAreaCode = ''
      this.queryParams.code = bizCode
      this.queryParams.storageLocCode = ''
      this.queryParams.trayCode = ''
      this.$refs.SearchComponent.searchFrom.storageAreaCode = ''
      this.$refs.SearchComponent.searchFrom.storageLocCode = ''
      this.$refs.SearchComponent.searchFrom.trayCode = ''
      this.queryWmsStorageAreaDropDownBox()
      this.getList()
    },
    selectWmsTrayList() {
      console.log('this.queryParams.storageLocCode:',this.queryParams.storageLocCode);
      selectWmsTrayList({ storageLocCode: this.queryParams.storageLocCode })
        .then((res) => {
          if (res.flag) {
            this.selectOrInputList[2].list = res.data.items
            console.log('this.selectOrInputList:',this.selectOrInputList);
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    queryWmsStorageLocationDropDownBox() {
      queryWmsStorageLocationDropDownBox({ storageAreaCode: this.queryParams.storageAreaCode })
        .then((res) => {
          if (res.flag) {
            this.selectOrInputList[1].list = res.data
            console.log('this.selectOrInputList1:',this.selectOrInputList);
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    queryWmsStorageAreaDropDownBox() {
      queryWmsStorageAreaDropDownBox({ code: this.activeBox })
        .then((res) => {
          if (res.flag) {
            this.selectOrInputList[0].list = res.data
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getList(val) {
      console.log(val, 'val--')
      if (val) {
        this.queryParams.pageNo = val.pageNo
        this.queryParams.pageSize = val.pageSize
      }

      selectWmsTrayList(this.queryParams)
        .then((res) => {
          console.log('selectWmsTrayList res.data--',res.data);
          if (res.flag) {
            this.tableData = res.data.items
            this.total = res.data.totalCount
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    queryDropDownBox(value) {
      queryDropDownBox({ searchValue: value })
        .then((res) => {
          if (res.flag) {
            this.treeList = res.data
            if (this.treeList.length) {
              this.activeBox = this.treeList[0].bizCode
              this.name = this.treeList[0].name
              this.queryParams.code = this.activeBox
              this.getList()
              this.queryWmsStorageAreaDropDownBox()
            }
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    submitFrom() {},
    cancel() {},
    handleSearch(query, type) {
      console.log(query, type, 'queryqueryquery------')
      // this.queryParams.pageNo = 1
      this.queryParams = Object.assign(this.queryParams, query)
      if (type == 'storageAreaCode') {
        // this.queryParams.storageAreaCode = ''
        this.queryParams.storageLocCode = ''
        this.queryParams.trayCode = ''
        // this.$refs.SearchComponent.searchFrom.storageAreaCode = ''
        this.$refs.SearchComponent.searchFrom.storageLocCode = ''
        this.$refs.SearchComponent.searchFrom.trayCode = ''
        this.queryWmsStorageLocationDropDownBox()
      }
      if (type == 'storageLocCode') {
        // this.queryParams.storageLocCode = ''
        this.queryParams.trayCode = ''
        // this.$refs.SearchComponent.searchFrom.storageAreaCode = ''
        // this.$refs.SearchComponent.searchFrom.storageLocCode = ''
        this.$refs.SearchComponent.searchFrom.trayCode = ''
        this.selectWmsTrayList()
      }
      // this.queryDropDownBox()
      this.getList()
    },
    handleReset() {
      this.pageNo = 1
      this.pageSize = 10
      this.queryParams.storageAreaCode = ''
      this.queryParams.storageLocCode = ''
      this.queryParams.trayCode = ''
      this.$refs.SearchComponent.searchFrom.storageAreaCode = ''
      this.$refs.SearchComponent.searchFrom.storageLocCode = ''
      this.$refs.SearchComponent.searchFrom.trayCode = ''
      this.getList()
    },
    handleNavSearch(query) {
      this.queryDropDownBox(query)
      console.log(query, 'queryqueryquery----')
    },
    //新增仓库
    isWarehousefun() {
      this.currentView = 'myform'
      this.dialogVisible = true
    },
    submitFormAdd(){
      this.$refs.myform.submit((res) => {
        if (res) {
          this.$message.success('添加成功')
          this.dialogVisible = false
            this.getList()
            this.queryWmsStorageAreaDropDownBox()
        }
      })
    },  
    cancelAdd(){
      this.$refs.myform.reset()
      this.dialogVisible = false
    },
      
    //新增库区库位
    isWarehouseAreafun() {
      if(!this.queryParams.code){
        this.$messag.error('请选择仓库')
        return;
      }
      this.currentView = 'areaform'
      this.areaDialogVisible = true;
      let params = {
        warehouseCode:this.queryParams.code,
        name:this.name,
      }
      this.$nextTick(() => {
         this.$refs.areaform.getDetail(params)
      })
    },
     submitFormArea(){
      this.$refs.areaform.submit((res) => {
        if (res) {
          this.$message.success('添加成功')
          this.areaDialogVisible = false
          this.queryDropDownBox()
        }
      })
    },
    cancelArea(){
      this.$refs.areaform.reset()
      this.areaDialogVisible = false
    },
    synchronousfun() {
      syncData()
        .then((res) => {
          if (res.flag) {
            this.$message.success('同步成功')
            this.getList()
          } else {
            this.$message.error(res.message)
          }
        })
        .catch((error) => {
          this.$message.error(error.message)
        })
    },
  },
}
</script>

<style lang='less' scoped>
// @import '../../../assets/styles/newIndex';
// @import 'src/assets/styles/heightTable';
// @import 'src/assets/styles/form.scss';
.disable {
  color: red;
}
.normal {
  color: green;
}
/deep/ .delbutton.el-button--text {
  color: red;
}
/deep/ .el-button--text {
  font-size: 14px;
}
.left-right {
  display: flex;
  .left {
    width: 180px;
  }
  .right {
    flex: 1;
    margin-left: 20px;
  }
}
</style>
